import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    iframeContainer: {
        width: '100%',
        height: '860px',
    },
    paymentMethodButton: {
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        margin: '0 auto !important',
        position: 'relative',
        bottom: '2rem',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '0 24px',
            bottom: '3rem',
        },
    },
    checkBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {},
    },
    oneOffButton: {
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '2rem 2.5rem',
        },
    },
    PaymentIframeModal: {
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
        },
    },
    amount: {
        display: 'flex',
        justifyContent: 'center',
        color: theme?.palette?.primary?.heather,
        paddingTop: '1.75rem',
    },
    paymentBox: {
        overflow: 'auto',
    },
    checkBoxText: {
        color: theme?.palette?.primary?.heather,
    },
    card: {
        padding: '1rem 0',
        width: '100%',
        [theme?.breakpoints?.down('sm')]: {
            padding: '1rem',
        },
    },
    cardInfo: {
        display: 'flex',
        flexDirection: 'row',
        color: theme?.palette?.primary?.heather,
    },
    formControl: {
        '& .MuiFormControlLabel-label': {
            width: '100%',
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'row',
            paddingLeft: '0.8rem',
            [theme?.breakpoints?.down('xs')]: {
                padding: '0.3rem',
            },
        },
    },
    radioBox: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme?.breakpoints?.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    ctaContainer: {
        paddingRight: '2rem',
        [theme?.breakpoints?.down('xs')]: {
            width: '100%',
            padding: '1rem 2.125rem 0 2.125rem',
        },
    },
    singlectaContainer: {
        paddingRight: '2.5rem',
        [theme?.breakpoints?.down('xs')]: {
            width: '100%',
            padding: '1rem 2.125rem 1rem 2.125rem',
        },
    },
    radioButton: {
        color: theme.palette.primary.heather,
        '&.Mui-checked': {
            color: theme.palette.primary.heather,
        },
    },
    expiry: {
        color: theme?.palette?.primary?.gray550,
    },

    toggleAccordionRoot: {
        width: '100%',
        margin: '0 !important',
        overflow: 'hidden',
        boxShadow: 'none',
        '& .MuiAccordionSummary-root': {
            [theme?.breakpoints?.down('sm')]: {
                padding: '1rem 1rem 0 1rem',
            },
        },
        '& .Mui-expanded': {
            borderRadius: '0',
            margin: '0 !important',
        },
    },
    methods: {
        padding: '2.5rem 1.5rem',
        [theme?.breakpoints?.down('sm')]: {
            padding: '1rem 0.5rem',
        },
    },
    expandMoreIcon: {
        color: theme?.palette?.primary?.sunset,
        fontSize: '2rem',
    },
    methodTitle: {
        color: theme?.palette?.primary?.heather,
    },
    savedCard: {
        width: '100%',
        [theme?.breakpoints?.down('xs')]: {
            padding: '0 0.5rem',
        },
    },
    singleSavedCard: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 1rem 1.5rem',
        [theme?.breakpoints?.down('xs')]: {
            padding: '0 1.5rem',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
        },
    },
    savedCardFlow: {
        width: '100%',
    },
    cardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    details: {
        width: '100%',
        [theme?.breakpoints?.down('sm')]: {
            padding: 0,
        },
    },
    toggleAccordion: {
        width: '100%',
        overflow: 'hidden',
        margin: '0 !important',
        boxShadow: 'none',
        '& .Mui-expanded': {
            borderRadius: '0',
            margin: '0 !important',
        },
        '& .MuiAccordionDetails-root': {
            display: 'flex',
            justifyContent: 'center',
            padding: 0,
        },
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        width: 'fit-content',
        paddingTop: '4rem',
    },
    paymentBackButton: {
        textTransform: 'capitalize',
        color: theme?.palette?.primary?.sunset,
    },
    successPopup: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },

    imgTextAdditional: {
        position: 'relative',
        fontSize: theme.typography.subtitle2.fontSize,
        fontFamily: theme.typography.body3Medium.fontFamily,
        letterSpacing: '0.25px',
        textAlign: 'center',
        lineHeight: '27px',
        margin: '1rem 0',
    },

    successImg: {
        marginTop: '12px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '19px',
            marginTop: '67px',
        },
    },
}));

export default useStyles;
